import { useQuery } from '@tanstack/react-query'
import { getOrganizations, getPhenotypes, getPhenotype } from '../api/phenotypes'
import { queryKeys } from '../lib/query-client'

/**
 * Hook to fetch list of organizations.
 */
export function useOrganizations() {
  return useQuery({
    queryKey: queryKeys.organizations.all,
    queryFn: getOrganizations,
    staleTime: 1000 * 60 * 30, // 30 minutes - orgs rarely change
  })
}

/**
 * Hook to fetch list of phenotypes, optionally filtered by org.
 */
export function usePhenotypes(orgId?: string) {
  return useQuery({
    queryKey: orgId ? queryKeys.phenotypes.byOrg(orgId) : queryKeys.phenotypes.all,
    queryFn: () => getPhenotypes(orgId),
    enabled: !!orgId,
    staleTime: 1000 * 60 * 10,
  })
}

/**
 * Hook to fetch single phenotype.
 */
export function usePhenotype(id: string | undefined, orgId?: string) {
  return useQuery({
    queryKey: [...queryKeys.phenotypes.detail(id || ''), orgId],
    queryFn: () => getPhenotype(id!, orgId),
    enabled: !!id,
  })
}
